import { Injectable } from '@angular/core';
import { CompanyService } from 'src/app/business/shared/company.service';
import { GenericResult } from 'src/app/globalClass/generic-class.model';
import { AnonymousSubject } from 'rxjs/internal/Subject';
import { element } from 'protractor';

@Injectable({
  providedIn: 'root'
})
export class TableEmpresaService {
  
  listaEmpresas:any=[];
  listCompanyName:any[]=[];
  listCompanySearch: any[] = [];
  companys:any[]=[];

  constructor(private _companyService:CompanyService) {
  }

  searchCompanyName(obj: any) {
    let name = obj.query;
    this.listCompanySearch = [];
    this._companyService.getAdmEmpresaSearch(name).then((i:any) => { 
        this.listCompanySearch = i as any[], 
        this.loadNameCompany() 
    });
  }

  loadNameCompany() {
    this.listCompanyName = [];
    if(this.listCompanySearch.length>0){
      for (var i = 0; i < this.listCompanySearch.length; i++) {
        this.listCompanyName.push(`${this.listCompanySearch[i].nombre} | ${this.listCompanySearch[i].nit}`);
      }
    }else{
      this.listCompanyName.push(`Sin información`);
    }
  }

  getListCompanyName(){
    return this.listCompanyName;
  }

  getListCompanySearch(){
    return this.listCompanySearch;
  }

  getListaEmpresa(){
    return this.listaEmpresas;
  }

  getCompanys(){
    return this.companys;
  }

  async getCompanyForNit(nit:string){
    return this._companyService.getCompanyForNit(nit);
  }

  addEmpresa(empresa:any){
    let tempEmp = this.listaEmpresas.find(x=>x.nit == empresa.nit);
    if (typeof tempEmp !== 'undefined' && tempEmp != null) {
      
    }else{
      this.companys.push(empresa.idAdmEmpresa);
      this.listaEmpresas.push(empresa);
    }
  }

  deleteEmpresa(idEmpresa:number){
    //debugger
    let list = this.listaEmpresas;
    this.listaEmpresas.splice(list.indexOf(list.find(s => s.idAdmEmpresa == idEmpresa)), 1);
    let listCompany = this.companys;
    this.companys.splice(listCompany.indexOf(listCompany.find(x=> x == idEmpresa)),1);
  }

  cleanList(){
    this.listaEmpresas = [];
    this.companys = [];
  }


  setEmpresaByUser(idUser:number){
    this._companyService.getEmpresasByUser(idUser).then((r:GenericResult)=>{
      if(r.error){

      }else{
        r.result.forEach((element)=>{
          this.addEmpresa(element);
        })
      }
    })
  }

}
